import { render, staticRenderFns } from "./tabulacao-form.vue?vue&type=template&id=035ee889&scoped=true"
import script from "./tabulacao-form.vue?vue&type=script&lang=js"
export * from "./tabulacao-form.vue?vue&type=script&lang=js"
import style0 from "./tabulacao-form.vue?vue&type=style&index=0&id=035ee889&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035ee889",
  null
  
)

export default component.exports